import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Tenant accounts", -1)
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Tenant details ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Applications ", -1)
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_11 = {
  key: 1,
  class: "d-flex flex-column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "pt-2 mx-4",
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                              width: "500",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tenant.name = ''))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "160",
                                  variant: "tonal",
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-store-plus",
                                      start: ""
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Add tenant' : 'Add'), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, { title: "Add a tenant" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_form, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "compact",
                                                      label: "Name",
                                                      modelValue: _ctx.tenant.name,
                                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenant.name) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: !_ctx.tenant.name || _ctx.loading,
                                          color: "primary",
                                          onClick: ($event: any) => {_ctx.addTenant(); isActive.value = false}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Add tenant ")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              size: "small",
                              width: "160",
                              variant: "tonal",
                              disabled: !_ctx.selectedTenants.length,
                              color: "primary",
                              onClick: _ctx.toggleSuspendTenant
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-store-off",
                                  start: ""
                                }),
                                _createTextVNode(" " + _toDisplayString((_ctx.mdAndUp ? (_ctx.selectedTenants.length && _ctx.selectedTenants[0].state === 'active' ? 'Suspend tenant' : 'Activate tenant') : (_ctx.selectedTenants.length && _ctx.selectedTenants[0].state === 'active' ? 'Suspend' : 'Activate'))), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, { width: "500" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "160",
                                  variant: "tonal",
                                  disabled: !_ctx.selectedTenants.length,
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-store-remove",
                                      start: ""
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Remove tenant' : 'Remove'), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["disabled"])
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, { "max-width": "460" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Remove tenant")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Are you sure you want to remove this tenant? ")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          onClick: ($event: any) => (isActive.value = false)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Cancel ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: _ctx.loading,
                                          color: "primary",
                                          onClick: ($event: any) => {_ctx.removeTenant(); isActive.value = false}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Remove ")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      "hide-details": "",
                      density: "compact",
                      placeholder: "Search tenants",
                      "append-inner-icon": "mdi-magnify",
                      modelValue: _ctx.searchNames,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchNames) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      loading: _ctx.loading,
      color: "primary",
      items: _ctx.tenants,
      headers: _ctx.headers,
      "show-select": "",
      modelValue: _ctx.selectedTenants,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTenants) = $event)),
      "return-object": "",
      height: "calc(100vh - 180px)",
      "fixed-header": "",
      "items-per-page": "25"
    }, {
      [`item.applications`]: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications, (app) => {
            return (_openBlock(), _createBlock(_component_v_tooltip, {
              key: app.id,
              location: "bottom",
              "open-delay": "200"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_avatar, _mergeProps(props, {
                  size: "32",
                  color: "secondary",
                  rounded: "",
                  class: "mx-1"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(app.name.charAt(0)), 1)
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                (app.type !=='hybrid')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(app.name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "auto" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(app.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Applications in this hybrid app:")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(app.details.applications, (subApp) => {
                        return (_openBlock(), _createBlock(_component_v_row, {
                          "no-gutters": "",
                          key: subApp.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-circle-small")
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(subApp.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      [`item.state`]: _withCtx(({ item }) => [
        (item.state === 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "success"
              }),
              _createTextVNode(" Active ")
            ]))
          : _createCommentVNode("", true),
        (item.state === 'suspended')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "amber"
              }),
              _createTextVNode(" Suspended ")
            ]))
          : _createCommentVNode("", true)
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        (item.state !== 'suspended')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "ma-1",
              width: "80",
              size: "small",
              variant: "tonal",
              color: "primary",
              onClick: ($event: any) => {_ctx.editTenant(item);}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Edit")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (item.state !== 'suspended')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              class: "ma-1",
              size: "small",
              width: "80",
              variant: "tonal",
              onClick: ($event: any) => (_ctx.manageTenant(item.id)),
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Manage")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, 1032, ["loading", "items", "headers", "modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": [
        _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editDialog) = $event)),
        _cache[15] || (_cache[15] = ($event: any) => {_ctx.logo = []; _ctx.applicationsToRegister = [];})
      ]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "Edit tenant" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Name",
                              "hide-details": "",
                              density: "comfortable",
                              modelValue: _ctx.currentTenant.name,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentTenant.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (!_ctx.currentTenant?.theme_configuration?.logo || !_ctx.savedLogo)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12",
                              class: "pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_file_input, {
                                  color: "primary",
                                  clearable: "",
                                  label: !_ctx.logo.length ? 'Select or drop a logo' : '',
                                  density: "comfortable",
                                  "prepend-icon": "",
                                  modelValue: _ctx.logo,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.logo) = $event)),
                                  counter: "",
                                  "counter-size-string": "Max 1MB",
                                  "show-size": "",
                                  rules: _ctx.rules,
                                  accept: "image/png"
                                }, {
                                  "append-inner": _withCtx(() => [
                                    (!_ctx.logo.length)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          color: "primary",
                                          icon: "mdi-image"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["label", "modelValue", "rules"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.currentTenant?.theme_configuration?.logo)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.savedLogo)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      dense: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: _ctx.savedLogo,
                                              alt: "logo",
                                              width: "200",
                                              height: "64"
                                            }, null, 8, ["src"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              color: "primary",
                                              variant: "plain",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.savedLogo = ''; _ctx.logo = [];})
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Clear logo")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Primary colour",
                              "hide-details": "",
                              density: "comfortable",
                              modelValue: _ctx.primary,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.primary) = $event)),
                              color: "primary"
                            }, {
                              "append-inner": _withCtx(() => [
                                _createVNode(_component_v_menu, {
                                  "close-on-content-click": false,
                                  modelValue: _ctx.primaryDialog,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.primaryDialog) = $event))
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({ color: _ctx.primary }, props, { icon: "mdi-palette" }), null, 16, ["color"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_color_picker, {
                                      mode: "hex",
                                      modelValue: _ctx.primary,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.primary) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Secondary colour",
                              "hide-details": "",
                              density: "comfortable",
                              modelValue: _ctx.secondary,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.secondary) = $event)),
                              color: "secondary"
                            }, {
                              "append-inner": _withCtx(() => [
                                _createVNode(_component_v_menu, {
                                  "close-on-content-click": false,
                                  modelValue: _ctx.secondaryDialog,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.secondaryDialog) = $event))
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({ color: _ctx.secondary }, props, { icon: "mdi-palette" }), null, 16, ["color"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_color_picker, {
                                      mode: "hex",
                                      modelValue: _ctx.secondary,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.secondary) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              justify: "space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "auto" }, {
                                  default: _withCtx(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "auto" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      size: "small",
                                      color: "primary",
                                      variant: "plain",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addApplicationRow(_ctx.currentTenant)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          start: "",
                                          icon: "mdi-plus-circle"
                                        }),
                                        _createTextVNode(" Add ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTenant.applications, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: app.name,
                                    style: {"background-color":"rgba(0,0,0,0.05)"},
                                    rounded: "",
                                    class: "my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "flex-nowrap",
                                        justify: "space-between",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "11" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.description), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_action, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_dialog, { attach: true }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn, _mergeProps(props, {
                                                        icon: "",
                                                        variant: "plain",
                                                        color: "primary",
                                                        size: "small"
                                                      }), {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            icon: "mdi-delete",
                                                            size: "large"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1040)
                                                    ]),
                                                    default: _withCtx(({ isActive }) => [
                                                      _createVNode(_component_v_card, { "max-width": "460" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_card_title, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("Remove application from tenant account")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_card_text, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Are you sure you want to remove this application from this tenant account? Users in this tenant will no longer have access to the application or its data. ")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_card_actions, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_spacer),
                                                              _createVNode(_component_v_btn, {
                                                                onClick: ($event: any) => (isActive.value = false)
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Cancel ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]),
                                                              _createVNode(_component_v_btn, {
                                                                loading: _ctx.loading,
                                                                disabled: _ctx.loading,
                                                                color: "primary",
                                                                onClick: ($event: any) => {_ctx.unregisterApplication(app); isActive.value = false}
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Remove ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["loading", "disabled", "onClick"])
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationsToRegister, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: app.name,
                                    style: {"background-color":"rgba(0,0,0,0.05)"},
                                    rounded: "",
                                    class: "my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        justify: "space-between",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "11" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.description), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_action, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, {
                                                    icon: "",
                                                    variant: "plain",
                                                    color: "primary",
                                                    size: "small",
                                                    onClick: ($event: any) => (_ctx.removeNewApplication(app))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        icon: "mdi-delete",
                                                        size: "large"
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newApps, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    class: "mb-1 px-0 pt-0",
                                    key: app.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_combobox, {
                                        class: "app-combobox",
                                        clearable: "",
                                        items: _ctx.filteredApplications,
                                        "item-title": "name",
                                        "hide-details": "",
                                        density: "comfortable",
                                        placeholder: "Search applications",
                                        "return-object": "",
                                        "menu-props": { maxWidth: 452 }
                                      }, {
                                        selection: _withCtx(({ item }) => [
                                          _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.raw.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.raw.description), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        item: _withCtx(({ item }) => [
                                          (_ctx.applicationOverlapsWithHybrid(item))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                _createVNode(_component_v_tooltip, {
                                                  text: item.errorMessage,
                                                  location: "bottom",
                                                  "open-delay": "200"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                                      _createVNode(_component_v_list_item, {
                                                        onClick: ($event: any) => {_ctx.newApp = item.raw; _ctx.addApplicationAccess()},
                                                        disabled: true
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_list_item_subtitle, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ], 16)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["text"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createVNode(_component_v_list_item, {
                                                  onClick: ($event: any) => {_ctx.newApp = item.raw; _ctx.addApplicationAccess()}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_list_item_subtitle, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]))
                                        ]),
                                        _: 1
                                      }, 8, ["items"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.saveTenant,
                  loading: _ctx.loading,
                  disabled: _ctx.loading || _ctx.invalidLogo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save tenant ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}